/**
 * Capitalise un prénom : première lettre de chaque partie en majuscule,
 * reste en minuscule, en respectant les séparateurs (espace, tiret, apostrophe).
 *
 *   fakhreddine   → Fakhreddine
 *   jean-pierre   → Jean-Pierre
 *   marie claire  → Marie Claire
 *   d'artagnan    → D'Artagnan
 */
export function capitalizeFirstName(name: string): string {
  if (!name) return name
  return name
    .split(/([\s\-'])/) // sépare mais garde les séparateurs comme éléments
    .map((part) => {
      if (part.length === 0) return part
      if (/^[\s\-']$/.test(part)) return part
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
    })
    .join('')
}

/**
 * Compare deux personnes pour un classement alphabétique français : d'abord le
 * nom de famille, puis le prénom en cas d'homonymie. Les accents et la casse
 * sont ignorés, si bien que « Éloïse » se range bien entre « Delmas » et
 * « Foltyn », et non en fin de liste.
 */
export function compareByLastName(
  a: { first_name?: string | null; last_name?: string | null },
  b: { first_name?: string | null; last_name?: string | null },
): number {
  const options: Intl.CollatorOptions = { sensitivity: 'base' }
  const parNom = (a.last_name || '').localeCompare(b.last_name || '', 'fr', options)
  if (parNom !== 0) return parNom
  return (a.first_name || '').localeCompare(b.first_name || '', 'fr', options)
}
